import data from './data'

export const reducer = data
